// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2QF5v","requiredAsterisk":"Info_requiredAsterisk__bJrUf"};